import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { User } from 'Core/models';
import { CurrentUserStateService, UserRequestService } from 'Core/services';
import { isNil } from 'lodash';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserResolver implements Resolve<User> {
  constructor(
    private readonly userRequestService: UserRequestService,
    private readonly currentUserStateService: CurrentUserStateService,
    private readonly permissionsService: NgxPermissionsService
  ) {}

  public resolve(): Observable<User> {
    const user: User | null = this.currentUserStateService.user();

    if (!isNil(user)) {
      this.permissionsService.loadPermissions(user.collectionRoles);
      return of(user);
    }

    return this.userRequestService.getPersonalInfo().pipe(
      tap({
        next: res => {
          const { currentUserStateService, permissionsService } = this;
          currentUserStateService.setUser(res);
          permissionsService.loadPermissions(res.collectionRoles);
        },
      })
    );
  }
}
